import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => {
  return {
    card: {
      width: '100%',
      marginBottom: theme.spacing(3),
      padding: 25,
    },
    containerTextField: {
      display: 'flex',
      flexDirection: 'row',
    },
    textField: {
      width: 300,
    },
    rowItems: {
      fontSize: '17px !important',
    },
    containerPagination: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 16,
    },
    btnTwo: {
      marginLeft: 16,
    },
    dialogContent: {
      borderRadius: 40,
      padding: 27,
      backgroundColor: '#f2f2f7',
    },
    tableContainer: {
      width: '100%',
      overflowX: 'auto',
    },
  };
});
